import axios from '@/http/axios';

export default {
  fetch: (oid) => {
    return axios.get(`/businesses/${oid}/preference`);
  },
  update: (oid, config: any = {}) => {
    return axios.put(`/businesses/${oid}/preference`, config);
  },
};
